import * as React from "react";
import { SVGProps } from "react";

const AllergyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 20 20" fill="none" {...props}>
    <rect
      width={18}
      height={18}
      x={1}
      y={1}
      stroke={props.color}
      strokeWidth={2}
      rx={9}
    />
    <rect
      width={2}
      height={20}
      x={2.222}
      y={3.636}
      fill={props.color}
      rx={1}
      transform="rotate(-45 2.222 3.636)"
    />
  </svg>
);
export default AllergyIcon;
